/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Box } from "@mui/material";
import CircularLoading from "../../components/CircularLoading";
import { FirebaseContext } from "common";
import { features, language } from "config";
import Material_React_Table from "../../components/React_Material_Table/Material_React_Table";

export default function DoctorPrescriptionForm() {
  const { api } = useContext(FirebaseContext);
  const { sendNotification, editNotifications } = api;

  const [data, setData] = useState([]);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });

  const prescriptiondata = useSelector((state) => state.notificationdata); // Replace with correct state
  const dispatch = useDispatch();

  useEffect(() => {
    if (prescriptiondata.notifications) {
      setData(prescriptiondata.notifications);
    } else {
      setData([]);
    }
  }, [prescriptiondata.notifications]);

  const columns = [
    {
      header: "Patient ID",
      accessorKey: "patientId",
    },
    {
      header: "Patient Name",
      accessorKey: "patientName",
    },
    {
      header: "Prescription",
      accessorKey: "prescription",
    },
    {
      header: "Date",
      accessorKey: "date",
    },
    {
      header: "Upload Document",
      accessorKey: "uploadDocument",
      cell: () => <input type="file" />,
    },
    {
      header: "Consent Form",
      accessorKey: "consentForm",
      cell: () => <input type="file" />,
    },
  ];

  // const onRowAdd = (newData) =>
  //   new Promise((resolve) => {
  //     setTimeout(() => {
  //       resolve();
  //       const tblData = data;
  //       tblData.push(newData);
  //       features.AllowCriticalEditsAdmin
  //         ? dispatch(sendNotification(newData))
  //         : alert(language.demo_mode);
  //       dispatch(editNotifications(newData, "Add"));
  //     }, 600);
  //   });

  // const onRowUpdate = (newData, oldData) =>
  //   new Promise((resolve) => {
  //     setTimeout(() => {
  //       resolve();
  //       dispatch(editNotifications(newData, "Update"));
  //     }, 600);
  //   });

  // const onRowDelete = (oldData) =>
  //   new Promise((resolve) => {
  //     setTimeout(() => {
  //       resolve();
  //       dispatch(editNotifications(oldData, "Delete"));
  //     }, 600);
  //   });

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  // const handleBulkDelete = () => {
  //   const updatedData = tableData.filter(row => !selectedRows.includes(row))
  //   setTableData(updatedData)
  // }


    const onRowAdd = (newData) => {
      Promise.resolve(setTableData([...tableData, newData]));

    };
    const onRowUpdate = (newData) => {
      Promise.resolve(setTableData([...tableData, newData]));

    }
    const onRowDelete = (newData) => {
      Promise.resolve(setTableData([...tableData, newData]));
    };

    return (
      <Box>
    {/* <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
      {commonAlert.msg}
    </AlertDialog> */}
    <Material_React_Table
      data={tableData}
      columns={tableColumns}
      userInitialState={{
        columnVisibility: { id: false }, // This hides the "id" column initially
      }}
      onRowAdd={onRowAdd}
      onRowUpdate={onRowUpdate}
      onRowDelete={onRowDelete}
    />
  </Box>
    );
  }
